import { queryOptions, useMutation } from '@tanstack/react-query'

import type { TResponseError } from '@/core/types/axios'
import type { TMutation } from '@/core/types/react-query'

import { USER_LIST_KEY } from './user.constants'
import {
  createUser,
  getUserList,
  getUserListPaged,
  updateUser,
} from './user.service'
import type {
  TCreateUserRequest,
  TUpdateUserRequest,
  TUser,
} from './user.types'

// Tümünü çeken sorgu — detay/düzenleme sayfalarının id ile bulması için.
export function userListQueryOptions() {
  return queryOptions({ queryKey: USER_LIST_KEY, queryFn: getUserList })
}

// Liste sayfası için sayfalı sorgu. Anahtar `USER_LIST_KEY` ile aynı önekte;
// mutasyon sonrası `['userList']` invalidasyonu bunu da kapsar.
export function userPagedQueryOptions(page: number, query: string) {
  return queryOptions({
    queryKey: [...USER_LIST_KEY, 'paged', page, query],
    queryFn: () => getUserListPaged(page, query),
  })
}

export function useCreateUser({
  onSuccess,
  onError,
}: TMutation<TUser, TResponseError, TCreateUserRequest>) {
  return useMutation<TUser, TResponseError, TCreateUserRequest>({
    mutationFn: createUser,
    onSuccess,
    onError,
  })
}

export function useUpdateUser({
  onSuccess,
  onError,
}: TMutation<TUser, TResponseError, { id: string; body: TUpdateUserRequest }>) {
  return useMutation<
    TUser,
    TResponseError,
    { id: string; body: TUpdateUserRequest }
  >({
    mutationFn: ({ id, body }) => updateUser(id, body),
    onSuccess,
    onError,
  })
}
